<template>
    <span :class="`text-${color}`">$</span>
</template>

<script lang="ts" setup>
    withDefaults(
        defineProps<{
            color?: string;
        }>(),
        {
            color: 'green',
        },
    );
</script>

<style lang="scss" scoped></style>
